<template>
    <modal name="create_promocode" height="auto" scrollable adaptive>
        <app-card :title="$t('Create promocode')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <promocode-form :form="form"/>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import PromocodeService from '@services/promocode.service';
import PromocodeForm from './components/Form';
import moment from 'moment';

export default {
    data() {
        return {
            form: {
                start_date: moment(new Date()).format('L'),
                end_date: moment(new Date()).format('L'),
                code: null,
                discount_percent: null
            },
            loading: false
        };
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    PromocodeService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setPromocode', res);
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_promocode');
        }
    },
    components: {
        PromocodeForm
    }
};
</script>
